import * as stylex from "@stylexjs/stylex";
import type { AriaRole, ReactNode } from "react";
import "@/design/tokens.stylex";
import { colors, radii, space } from "@/design/tokens.stylex";

// A full-height page outside the app frame holding one bordered card in its
// middle: sign-in, OAuth consent, no Company access, and the root error. The
// page owns what goes in the card; `xstyle` adjusts the card (gap, alignment),
// `below` sits under it (sign-in's Privacy · Contact).

const styles = {
  page: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kAzted: "xg6iff7",
    kmVPX3: "xze2s60",
    kWkggS: "x19qxo9d",
    $$css: true
  },
  column: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1l51sop",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  sm: {
    ks0D6T: "x1dt7z5j",
    $$css: true
  },
  md: {
    ks0D6T: "x1lr1uin",
    $$css: true
  },
  lg: {
    ks0D6T: "x1pfbilc",
    $$css: true
  },
  card: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x166cprz",
    kzqmXN: "xh8yej3",
    kmVPX3: "x15677zm",
    kWkggS: "x1h1f4i9",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xzbo3x7",
    kaIpWk: "xhrzdqn",
    $$css: true
  }
};
export default function CenteredCard({
  children,
  width = "md",
  role,
  below,
  xstyle
}: {
  children: ReactNode;
  /** 380, 420 or 460 px at most. */
  width?: "sm" | "md" | "lg";
  role?: AriaRole;
  /** Quiet content under the card. */
  below?: ReactNode;
  xstyle?: stylex.StyleXStyles;
}) {
  return <main className="x78zum5 x6s0dn4 xl56j7k xg6iff7 xze2s60 x19qxo9d">
      <div {...stylex.props(styles.column, styles[width])}>
        <div role={role} {...stylex.props(styles.card, xstyle)}>
          {children}
        </div>
        {below}
      </div>
    </main>;
}